module.exports = __webpack_public_path__ + "img/success_0.7f125021.gif";